import React from 'react';

class Checkbox extends React.Component {
   render() {
        return (
            <div className={ 'checkbox' } >
                <label>
                    <input
                        name={this.props.name}
                        checked={this.props.value}
                        type={'checkbox'}
                        onChange={ this.props.onChange }
                        disabled={ this.props.disabled }
                    />
                    {this.props.label}
                </label>
            </div>
        )
    }
}

export default Checkbox;